import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';
import { RoutingUrl } from 'src/shared/constant/route-const';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(private readonly router: Router, private readonly userService: UserService) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.userService.user;
    const userToken = user?.token ? user.token : undefined;
    const currentUrl = state.url;
    if (
      !userToken &&
      (currentUrl.indexOf('authCode') >= 0 ||
        currentUrl.indexOf('state') >= 0 ||
        currentUrl.indexOf('borrowerId') >= 0 ||
        currentUrl.indexOf('loanNumber') >= 0 ||
        currentUrl.indexOf('leadid') >= 0 ||
        currentUrl.indexOf('accesstoken') >= 0)
    ) {
      return true;
    }

    if (!userToken && !state.url.includes(RoutingUrl.Login)) {
      this.router.navigate([RoutingUrl.Login]);
      return false;
    } else if (userToken && state.url.includes(RoutingUrl.Login)) {
      this.router.navigate([RoutingUrl.Dashboard]);
      return false;
    }
    return true;
  }
}
